import { ProductPageLayout } from '../components/ProductPageLayout';

export function Sora2PromptPage() {
    return <ProductPageLayout productId="sora2-prompt" />;
}
